






































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useFormat } from 'vivat';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import CommonChip from '@/components/CommonChip.vue';
import CommonIconTop from '@/components/CommonIconTop.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

import cashFlowList from '@/table/cashFlow/cashFlow';

import getCashFlows from '@/gql/cashflow/getCashFlows.gql';
import updateCashflow from '@/gql/cashflow/updateCashflow.gql';
import getCashFlowStats from '@/gql/cashflow/getCashFlowStats.gql';

const Overall = defineComponent({
  components: {
    CommonChip,
    CommonIconTop,
    CommonModalWithPreset,
  },
  setup() {
    const NOW = useFormat.date().computerShortDate();
    const colorIndex = ref(0);
    const COLORS = ['pink', 'green', 'blue', 'yellow', 'red', 'gray', 'orange', 'teal', 'indigo', 'purple'];
    const filterDate = ref(NOW);
    const displayDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const toCurrency = (str: string | number) => useFormat.number(str).currency();

    const getCashFlowsVariables = computed(() => {
      const vars: {[key: string]: any} = {
        first: 5,
      };
      return vars;
    });

    const { result: cashFlowStatsResult, loading: cashflowStatsLoading } = useQuery(getCashFlowStats, () => ({ fetchPolicy: 'network-only' }));
    const cashFlowStats = useResult(cashFlowStatsResult, {
      monthlySum: 0,
      pendingSum: 0,
      monthlyPaidSum: 0,
      countByCategories: [],
      sumByMonths: [],
      countPaid: { paginatorInfo: { total: 0 } },
      countPending: { paginatorInfo: { total: 0 } },
    }, (data: any) => ({
      ...data.cashFlowStats,
      countByCategories: data.cashFlowStats.countByCategories.map((category: { data: number; name: string }) => {
        if (colorIndex.value === 9) colorIndex.value = 0;
        else colorIndex.value += 1;
        return {
          ...category,
          color: COLORS[colorIndex.value],
        };
      }),
      countPaid: data.countPaid.paginatorInfo.total,
      countPending: data.countPending.paginatorInfo.total,
    }));
    const donutChart = computed(() => ([
      { name: 'รายการชำระแล้ว', data: cashFlowStats.value.countPaid, color: 'green' },
      { name: 'รายการค้างชำระ', data: cashFlowStats.value.countPending, color: 'red' },
    ]));

    const totalYearIncome = ref(0);
    watch(() => cashFlowStatsResult.value, () => {
      if (!cashflowStatsLoading.value) totalYearIncome.value = 0;
    });

    const thMonthsMini = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    const computedSeriesData = computed(() => cashFlowStats.value.sumByMonths.map((val: any) => {
      totalYearIncome.value += val.sum;
      return {
        x: thMonthsMini[val.month - 1],
        y: val.sum,
      };
    }));

    const areaCharts = computed(() => ({
      options: {
        dataLabels: { enabled: false },
        yaxis: { opposite: false },
      },
      series: [
        {
          name: 'รายรับประจำปี',
          data: computedSeriesData.value,
        },
      ],
    }));

    // Use to updateCashFlowStatus
    const confirmModal = ref(null);
    const pendingUpdateCashFlow = reactive({
      id: -1,
      status: 'PENDING',
    });
    const updateCashFlowStatusMutation = useMutation(updateCashflow, () => ({
      variables: {
        input: pendingUpdateCashFlow,
      },
      refetchQueries: ['getCashFlows', 'getCashFlowStats'],
    }));
    updateCashFlowStatusMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
      pendingUpdateCashFlow.id = -1;
    });
    function updateCashFlowStatusHandler(id: number, status: string) {
      pendingUpdateCashFlow.id = id;
      pendingUpdateCashFlow.status = status;
      updateCashFlowStatusMutation.mutate();
    }

    return {
      cashflowStatsLoading,
      displayDate,
      toCurrency,
      filterDate,

      cashFlowTableOptions: cashFlowList,
      getCashFlows,
      getCashFlowsResult: (data: any) => data.cashFlows,
      getCashFlowsVariables,

      donutChart,
      areaCharts,

      cashFlowStats,
      totalYearIncome,

      // Use to update CashFlowStatus
      confirmModal,
      updateCashFlowStatusHandler,
    };
  },
});

export default Overall;
